import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.hmr';

@Injectable({
  providedIn: 'root'
})
export class GeradorPlanilhaService {

  API = environment.API

  constructor(private httpClient: HttpClient) { }

  post(corpo: FormData): Observable<HttpEvent<Blob>> {
    return this.httpClient.post<Blob>(`${this.API}GeradorPlanilha/Gerar-Tributacao`, corpo, {
      observe: 'events',
      reportProgress: true,
      responseType: 'blob' as 'json'
    })
  }
}
